// extracted by mini-css-extract-plugin
export default {"unread":"unreadLabel_unread__wpNuT"};